<template>
  <div>
    <b-row>
      <b-col cols="12">
        <ListAssets />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ListAssets from '@/views/assets/ListTable'

export default {
  components: {
    BRow,
    BCol,
    ListAssets,
  },
}
</script>
